import "@/types"

export default {
  namespaced: true,
  
  state: {
    items: []
  },

  mutations: {
    putView: (state, payload:{item:ViewItem, resource:string}) => {
      const { item, resource } = payload
      const views:ViewItem[] = state.items
      const index = state.items.findIndex(view => view.id == item._id)
      index > -1 ? state.items.splice(index, 1, item) : state.items.push(item)
    },
    setItem(state, item) {
      const index = state.items.findIndex(i => i.id == item.id)
      state.items.splice(index, 1, item)
    }
  },

  actions: {
    setItem({commit}, item) {
      return new Promise((resolve, reject) => {
        try {
          commit('setItem', item)
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    viewPut({commit}, payload) {
      return new Promise((resolve) => {
        payload.views.forEach((view:ViewItem) => {
          commit('putView', {item: view, resource: payload.resource})
        })
        resolve()
      })
    },
  },

  getters: {

  }
}